import {NODECommonApi, PHPCommonApi} from '../common';
import {
  StationAuthenticationResponseSchema,
  StationDashboardResponseSchema,
  StationSchema,
} from '@/types/channel/station/station.schema';

export const getWithDraw = async (userId: string) => {
  return PHPCommonApi.get<{withDraw: 0 | 1}>(`/${userId}/withDraw`);
};

export const getAuthentication = async () => {
  return PHPCommonApi.get<StationAuthenticationResponseSchema>(
    `/authentication`,
  );
};

export const getStationInfo = async (userId: string) => {
  return NODECommonApi.get<StationSchema>(`${userId}/station`);
};

export const getStationDashboard = async (userId: string) => {
  return NODECommonApi.get<StationDashboardResponseSchema>(
    `${userId}/dashboard`,
  );
};
